import ChevronLeft from "@mui/icons-material/ChevronLeft";
import ChevronRight from "@mui/icons-material/ChevronRight";
import { Box, IconButton } from "@mui/material";
import { useState } from "react";
import type { CampsiteImage } from "@/types/api";

interface ImageCarouselProps {
  images: CampsiteImage[];
  variant?: keyof CampsiteImage["variants"];
  opacity?: number;
}

export default function ImageCarousel({
  images,
  variant = "1_1",
  opacity = 1,
}: ImageCarouselProps) {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  const hasMultipleImages = images.length > 1;

  const handlePrevious = () => {
    setCurrentImageIndex((prev) => (prev === 0 ? images.length - 1 : prev - 1));
  };

  const handleNext = () => {
    setCurrentImageIndex((prev) => (prev === images.length - 1 ? 0 : prev + 1));
  };

  if (images.length === 0) {
    return null;
  }

  return (
    <Box
      sx={{
        width: "100%",
        height: "100%",
        position: "relative",
        overflow: "hidden",
      }}
    >
      <Box
        sx={{
          display: "flex",
          height: "100%",
          transform: `translateX(-${currentImageIndex * 100}%)`,
          transition: "transform 0.3s ease-in-out",
        }}
      >
        {images.map((image) => (
          <Box
            key={image.variants[variant].url}
            component="img"
            src={image.variants[variant].url}
            alt={image.title}
            sx={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
              flexShrink: 0,
              opacity,
            }}
          />
        ))}
      </Box>
      {hasMultipleImages && (
        <>
          <IconButton
            onClick={(e) => {
              e.stopPropagation();
              handlePrevious();
            }}
            size="medium"
            sx={{
              position: "absolute",
              left: 2,
              top: "50%",
              transform: "translateY(-50%)",
              zIndex: 2,
              color: "white",
            }}
          >
            <ChevronLeft fontSize="large" />
          </IconButton>
          <IconButton
            onClick={(e) => {
              e.stopPropagation();
              handleNext();
            }}
            size="medium"
            sx={{
              position: "absolute",
              right: 2,
              top: "50%",
              transform: "translateY(-50%)",
              zIndex: 2,
              color: "white",
            }}
          >
            <ChevronRight fontSize="large" />
          </IconButton>
        </>
      )}
    </Box>
  );
}
